export var WebSocketMessageType;
(function (WebSocketMessageType) {
    WebSocketMessageType["Hello"] = "hello";
    WebSocketMessageType["Ready"] = "ready";
    WebSocketMessageType["Chat"] = "chat";
    WebSocketMessageType["Form"] = "form";
    WebSocketMessageType["Chips"] = "chips";
    WebSocketMessageType["Location"] = "location";
    WebSocketMessageType["Confirmation"] = "confirmation";
    WebSocketMessageType["AuthRequired"] = "auth-required";
    WebSocketMessageType["BotDetected"] = "bot-detected";
    WebSocketMessageType["FAQ"] = "faq";
    WebSocketMessageType["FaqAnswered"] = "faq-answered";
    WebSocketMessageType["StateChange"] = "state-change";
    WebSocketMessageType["Context"] = "context";
    WebSocketMessageType["Ping"] = "ping";
    WebSocketMessageType["Pong"] = "pong";
    WebSocketMessageType["Processing"] = "processing";
    WebSocketMessageType["Error"] = "error";
})(WebSocketMessageType || (WebSocketMessageType = {}));
//# sourceMappingURL=websocket.js.map